// Registro do service worker — apenas em produção, para o SW não interferir
// no vue-cli-service serve. updateViaCache "none" garante que atualizações do
// SW cheguem mesmo se algum intermediário cachear o arquivo.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .catch((err) => console.error("SW registration failed:", err));
  });
}
